import React from 'react';

import WebsiteReviews from '../../../js/components/acctHome/WebsiteReviews/WebsiteReviews';

const r = React;

export default (obj) => {
	const uid = parseInt(obj.split('-')[0]);

	return [
		{
			title: 'Reviews',
			pane: <WebsiteReviews uid={uid} />,
		},
	];
};
